import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faFolderOpen, faGears, faHouse, faPerson, faUser } from "@fortawesome/free-solid-svg-icons";

import "./Menu.css"
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";


interface AsideMenuProps {
    isOpen: boolean;
  }

  
const AsideMenu: React.FC<AsideMenuProps> = ({isOpen}) => {
    const { user } = useContext(AuthContext)

    return (
    <aside
      className={`aside-menu-container ${isOpen ? 'translate-x-0 open' : '-translate-x-full collapsed'}`}    
      >

        <div className="sidebar">
          {isOpen && 
            <img src="/Logo_bianco.png" alt="Logo" width={150} height={50} style={{paddingLeft: '2.5rem'}}/>
          }

          <nav className="pt-2">
            <ul className="nav-items nav-pills nav-sidebar flex-column" style={{paddingTop: isOpen ? '0' : '60px'}}>
              <NavLink
                  to='/'
                  className={({ isActive }) =>
                    `nav-item${isActive ? ' active' : ''}`
                    }
                  >
                    <FontAwesomeIcon icon={faGears}/> <span>Generazione</span>
              </NavLink>
              
              <NavLink
                  to='reports'
                  className={({ isActive }) =>
                    `nav-item${isActive ? ' active' : ''}`
                    }
                  >
                    <FontAwesomeIcon icon={faFolderOpen} /> <span>Report</span>
              </NavLink>

              { user?.isSuperuser &&<>
              <NavLink
                  to='users'
                  className={({ isActive }) =>
                    `nav-item${isActive ? ' active' : ''}`
                    }
                  >
                    <FontAwesomeIcon icon={faUser} /> <span>Utenti</span>
              </NavLink>
              <NavLink
                  to='consumptions'
                  className={({ isActive }) =>
                    `nav-item${isActive ? ' active' : ''}`
                    }
                  >
                    <FontAwesomeIcon icon={faDatabase} /> <span>Consumi</span>
              </NavLink>
              </>}

            </ul>
          </nav>
        </div>
      </aside>
    )
}

export default AsideMenu